/**
 * A class to store password reset requests
 */
export class BasePasswordResetRequest {
  /**
   * @param email - The user's email address
   */
  constructor(public email: string) {}
}
